// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"_1Z7o1G5t0V2gYri9qTP6O5"};